export const gaCode = 'UA-38174542-40'
